import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { Surgery } from '../../core/models/surgery.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';

export class PrivateSurgeriesTableConfigBuilder extends TableConfigBuilder<Surgery> {
  private idikaSurgeryOperationsEllipsisFunc:
    | ((item?: Surgery) => string)
    | undefined;

  private communicationFailedSurgeryFunc:
    | ((item?: Surgery, event?: any) => void)
    | undefined;

  private isCommunicationFailedSurgeryBtnVisibleFunc:
    | ((item?: Surgery) => boolean)
    | undefined;

  private surgeryStatusNameFunc: ((item?: Surgery) => string) | undefined;

  getColumns() {
    const columns = [
      new TextColumn({
        name: 'Μον. κωδικός ΕΛΧ',
        propertyName: 'uniqueListPatientCode',
      }),
      new TextColumn({
        name: 'Voucher',
        propertyName: 'surgeryCode',
      }),
      new TextColumn({
        name: 'ΑΜΚΑ',
        propertyName: 'patientAmka',
      }),
      new TextColumn({
        name: 'Κλινική',
        propertyName: 'clinicName',
      }),
      new TextColumn({
        name: 'Τύπος',
        propertyName: 'surgeryType',
      }),
      new DateColumn({
        name: 'Ημ. κλινικής εκτίμησης',
        propertyName: 'examinationDate',
      }),
      new DateColumn({
        name: 'Ημ. εισαγωγής στην ΕΛΧ',
        propertyName: 'listEntryDate',
      }),
      new DateColumn({
        name: 'Ημ. αποδέσμευσης',
        propertyName: 'releaseDate',
        tooltip: (item?: Surgery) => {
          if (item?.releaseDays && item?.releaseDays > 0) {
            return `${item.releaseDays} μέρες από την αποδέσμευση για ιδιωτική δομή`;
          }
          return '';
        },
      }),
      new TextColumn({
        name: 'Επεμβάσεις',
        propertyName: 'idikaSurgeryOperationsEllipsis',
        tooltip: (item?: Surgery) => {
          if (this.idikaSurgeryOperationsEllipsisFunc) {
            return this.idikaSurgeryOperationsEllipsisFunc(item);
          }
          return '';
        },
      }),
      new TextColumn({
        name: 'Κατάσταση',
        propertyName: 'surgeryStatusName',
        tooltip: (item?: Surgery) => {
          if (this.surgeryStatusNameFunc) {
            return this.surgeryStatusNameFunc(item);
          }
          return '';
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-times-circle p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Αδυναμία Επικοινωνίας',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.communicationFailedSurgeryFunc) {
            this.communicationFailedSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          //console.log('item  for visibility icon ', item);
          if (this.isCommunicationFailedSurgeryBtnVisibleFunc) {
            return this.isCommunicationFailedSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
    ];

    return columns;
  }

  addIdikaSurgeryOperationsEllipsisFunction(
    idikaSurgeryOperationsEllipsisFunc: (item?: Surgery) => string
  ): PrivateSurgeriesTableConfigBuilder {
    this.idikaSurgeryOperationsEllipsisFunc =
      idikaSurgeryOperationsEllipsisFunc;
    return this;
  }

  addIsCommunicationFailedSurgeryBtnVisibleFunction(
    isCommunicationFailedSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): PrivateSurgeriesTableConfigBuilder {
    this.isCommunicationFailedSurgeryBtnVisibleFunc =
      isCommunicationFailedSurgeryBtnVisibleFunc;
    return this;
  }

  addCommunicationFailedSurgeryFunction(
    communicationFailedSurgeryFunc: (item?: Surgery, event?: any) => void
  ): PrivateSurgeriesTableConfigBuilder {
    this.communicationFailedSurgeryFunc = communicationFailedSurgeryFunc;
    return this;
  }

  addSurgeryStatusNameFunction(
    surgeryStatusNameFunc: (item?: Surgery) => string
  ): PrivateSurgeriesTableConfigBuilder {
    this.surgeryStatusNameFunc = surgeryStatusNameFunc;
    return this;
  }

  getTable(data: Surgery[]): TableConfig<Surgery> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }
}
